import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css";
import App from "./App";
import AuthProvider from "./context/AuthContext";
import LocaleContextProvider from "./context/LocaleContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LocaleContextProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </LocaleContextProvider>
);
